import { api } from "../App";
import { SET_USEFUL_SITES_LIST, SET_USEFUL_SITES_LOADING } from "./types";

export const getLoginRegisterList = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_USEFUL_SITES_LOADING, payload: true });
    const { data } = await api.get('/login_register', { params });
    dispatch({ type: SET_USEFUL_SITES_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_USEFUL_SITES_LOADING, payload: false });
  }
}
